import React from 'react'

import type { UploadProps } from '@fourthwall/components'
import { Upload, useMediaQueryContext } from '@fourthwall/components'
import { UploadIcon } from '@fourthwall/icons'

import { FILE_TYPES, MAX_FILE_SIZE } from '../../const'
import * as S from './UploadMedia.styled'

type UploadMediaProps = {
  onFileDrop: UploadProps['onFileDrop']
  onFileDropRejected?: UploadProps['onFileDropRejected']
}

export const UploadMedia = ({ onFileDrop, onFileDropRejected }: UploadMediaProps) => {
  const media = useMediaQueryContext()

  return (
    <S.Container>
      <Upload
        title={
          <>
            <S.Title>
              {media.laptop ? (
                <>
                  Drop video or audio file here or <S.Underline>browse</S.Underline>
                </>
              ) : (
                <S.Underline>Browse</S.Underline>
              )}
            </S.Title>
            <S.Subtitle>Max {MAX_FILE_SIZE / (1024 * 1024)} MB file size</S.Subtitle>
          </>
        }
        icon={UploadIcon}
        maxSize={MAX_FILE_SIZE}
        accept={FILE_TYPES}
        onFileDrop={onFileDrop}
        onFileDropRejected={onFileDropRejected}
      />
    </S.Container>
  )
}
